export enum PeriodMode {
  All = 'all',
  CustomDate = 'dates',
  CustomDateFrom = 'from',
  CustomDateThrough = 'through',
  FiscalYear = 'fiscalyear',
  Month = 'month',
  Quarter = 'quarter',
}
